export default __webpack_public_path__ + "assets/85e743b73361f709260075d7522082d0.png";